import { render, staticRenderFns } from "./Provision.vue?vue&type=template&id=5ff03b04"
import script from "./Provision.vue?vue&type=script&lang=ts"
export * from "./Provision.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports